<mat-dialog-content>
  <div style="display: flex;flex: 1;width:100%;height: 100%;flex-direction: column;height:400px">
    <textarea style="height: 400px;"  #textArea [(ngModel)]="comment" autocomplete="off"  
    autocorrect="off" autocapitalize="off" spellcheck="false" ></textarea>
  
    
  </div>
</mat-dialog-content>

<mat-dialog-actions style="display: flex;
flex-direction: row;
justify-content: flex-end;">
  <button mat-raised-button (click)="closeModal()" >Cancel</button>
  <button mat-raised-button (click)="updateComment()">{{'Save Comment' | translate | async}}</button>
</mat-dialog-actions>
